module.exports = __webpack_public_path__ + "static/media/tune.2ee6f90a.svg";